export const validExpresionRegular = {
    numeros: /^[0-9]+$/
}

export function validMontoMin(value, montoMin) {
    let respuesta = false;
    if(value !== "" && value !== undefined) {
        const expMonetario = /[0-9]+[.|,]*[0-9]*[.|,]*[0-9]*/;
        const valor = expMonetario.test(value);
        const reemplaza = value.replace(/[^0-9\\.]+/g,'');
        if(valor && (reemplaza === 0 || reemplaza >= montoMin)){
            respuesta = true;
        } 
    }
    return respuesta;
}

export function validMontoMax(value, montoMax) {
    let respuesta = false;
    if(value !== "" && value !== undefined) {
        const expMonetario = /[0-9]+[.|,]*[0-9]*[.|,]*[0-9]*/;
        const valor = expMonetario.test(value);
        const reemplaza = value.replace(/[^0-9\\.]+/g,'');
        //999999999
        if(valor && reemplaza <= montoMax){
            respuesta = true;
        } 
    }
    return respuesta;
}

export const CARACTERES_ESPECIALES_PASSWORD = "*$%?!&";

export const REGLAS_PASSWORD = [
    { clave: "longitud", texto: "Entre 8 y 15 caracteres." },
    { clave: "mayuscula", texto: "Al menos una letra mayúscula." },
    { clave: "minuscula", texto: "Al menos una letra minúscula." },
    { clave: "digito", texto: "Al menos un número." },
    { clave: "especial", texto: `Al menos un carácter especial ( ${CARACTERES_ESPECIALES_PASSWORD.split("").join(" ")} ).` },
    { clave: "sinConsecutivosRepetidos", texto: "Sin letras o números repetidos más de tres veces seguidas." },
    { clave: "sinCaracteresRepetidos", texto: "Sin ningún carácter repetido más de tres veces seguidas." },
];

export function evaluarPassword(value) {
    const valor = value || "";
    return {
        longitud: valor.length >= 8 && valor.length <= 15,
        mayuscula: /[A-Z]/.test(valor),
        minuscula: /[a-z]/.test(valor),
        digito: /\d/.test(valor),
        especial: /[*$%?!&]/.test(valor),
        sinConsecutivosRepetidos: valor !== "" && !/([a-zA-Z\d])\1{2,}/.test(valor),
        sinCaracteresRepetidos: valor !== "" && !/(.)\1{2,}/.test(valor),
    };
}

export function validPassword(value) {
    const resultado = evaluarPassword(value);
    return REGLAS_PASSWORD.every(({ clave }) => resultado[clave]);
}